/* ========================================================================
   Carousels
 ========================================================================== */

app.carousel = (function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-carousel]').forEach((section) => {
      initGeneric(section);
    });

    document.querySelectorAll('[data-image-carousel]').forEach((section) => {
      initImageCarousel(section);
    });
  }

  function initGeneric(section) {
    const viewport = section.querySelector('[data-carousel-viewport]');
    const prevBtn = section.querySelector('[data-carousel-prev]');
    const nextBtn = section.querySelector('[data-carousel-next]');
    const items = section.querySelectorAll('[data-carousel-item]');

    //
    // Init carousel
    //

    const carousel = new EmblaCarousel(viewport, {
      inViewThreshold: 0.1,
      align: 'start',
      containScroll: 'trimSnaps',
      breakpoints: {
        '(min-width: 576px)': { draggable: false },
      },
    });

    //
    // Event listeners
    //

    carousel.on('init', (event) => {
      app.embla.onInit(prevBtn, nextBtn, viewport, carousel);
    });

    carousel.on('reInit', (event) => {
      app.embla.onReInit(prevBtn, nextBtn, carousel);
    });

    carousel.on('select', (event) => {
      app.embla.onSelect(prevBtn, nextBtn, carousel);
    });

    carousel.on('settle', (event) => {
      app.embla.onSettle(carousel);
    });
  }

  function initImageCarousel(section) {
    const imgViewport = section.querySelector('[data-carousel-viewport]');
    const imgItems = section.querySelectorAll('[data-carousel-item]');

    const textSectionId = 'carousel-' + section.dataset.sectionId;
    const textSection = document.getElementById(textSectionId);
    const showText = textSection.classList.contains('has-text');
    const imgCarouselDelay = showText ? 500 : 0;

    const textViewport = textSection.querySelector('[data-carousel-viewport]');
    const textItems = textSection.querySelectorAll('[data-carousel-item]');
    const textPrevBtn = textSection.querySelector('[data-carousel-prev]');
    const textNextBtn = textSection.querySelector('[data-carousel-next]');

    //
    // Init carousels
    //

    const imgCarousel = new EmblaCarousel(imgViewport, {
      inViewThreshold: 0.1,
      align: 'start',
      containScroll: 'trimSnaps',
      draggable: false,
    });

    const textCarousel = new EmblaCarousel(textViewport, {
      inViewThreshold: 0.1,
      align: 'start',
      containScroll: 'trimSnaps',
      draggable: false,
    });

    //
    // Event listeners
    //

    textCarousel.on('init', (event) => {
      app.embla.onInit(textPrevBtn, textNextBtn, textViewport, textCarousel);
    });

    textCarousel.on('reInit', (event) => {
      app.embla.onReInit(textPrevBtn, textNextBtn, textCarousel);
    });

    textCarousel.on('select', (event) => {
      const selected = textCarousel.selectedScrollSnap();
      app.embla.onSelect(textPrevBtn, textNextBtn, textCarousel);

      window.setTimeout(() => {
        imgCarousel.scrollTo(selected);
      }, imgCarouselDelay);
    });

    textCarousel.on('settle', (event) => {
      app.embla.onSettle(textCarousel);
    });
  }

  // Expose public functions and variables
  return {
    init: init,
    initGeneric: initGeneric,
  };
})();
